import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { IDisclaimerService } from './disclaimer.service';

@Injectable()
export class DisclaimerInterceptor implements HttpInterceptor {

    private disclaimerService: IDisclaimerService;

    constructor(private inj: Injector) {
        setTimeout(() => {
            this.disclaimerService = inj.get(IDisclaimerService);
        });
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.disclaimerService) {
            this.disclaimerService = this.inj.get(IDisclaimerService);
        }
        let headers = req.headers;
        this.disclaimerService.getHttpHeadersFromDisclaimerData().forEach((value, headerName) => {
            headers = headers.set(headerName, value);
        });
        return next.handle(req.clone({ headers: headers }));
    }
}
